import { useState } from "react";
import { useSnackbar } from "notistack";
import Loading from "../../../components/loading";
import FAQForm from "../../../components/f&qFormModal";
import blogsService from "../../../services/blogs.service";

export default function FAQModalContent({ close, data }) {
    const [waiting, setWaiting] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const { id, faq } = { ...data } || {};

    const handleSubmit = async (model) => {
        setWaiting(true);
        const { error } = await blogsService.faqBlog(id, model);
        setWaiting(false);
        if (error) {
            enqueueSnackbar("خطا در ذخیره سازی", { variant: "error" });
            return;
        } else {
            close(true);
        }
    };

    return (
        <Loading isLoading={waiting} fullPage={true} overlay>
            <FAQForm
                initValue={faq}
                close={close}
                handleSubmit={handleSubmit}
            />
        </Loading>
    );
}
